

  /* eslint-disable eqeqeq */
  import React, { useState, useEffect, useContext } from "react";
  import Axios from "axios";
  import Banner from "../Components/Banner";
  import clsx from "clsx";
  import { makeStyles } from "@material-ui/core/styles";
  import CircularProgress from "@material-ui/core/CircularProgress";
  import { green } from "@material-ui/core/colors";
  import { Link, useHistory, Redirect } from "react-router-dom";
  import StateContext from "../StateContext";
  import DispatchContext from "../DispatchContext";
  import Page from "../Components/Page";
  import LoginModal from "../Components/loginModal/loginModal";
  import VerifyPhoneNumber from "../Components/verifyPhoneNumber/verifyPhoneNumber";
  
  // import { useNavigate} from "react-router"
  import Snackbar from "@material-ui/core/Snackbar";
  import MuiAlert from "@material-ui/lab/Alert";
  import { withTranslation, useTranslation, Trans } from "react-i18next";
  //  cookie functions
  import { erase, getCookie, setCookie, parseCookieJson } from "../Functions/cookieFunction";
  import LoaderAnimation from "../Components/LoaderAnimation";
  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    wrapper: {
      marginTop: "1.5rem",
      position: "relative",
    },
    buttonSuccess: {
      backgroundColor: green[500],
      "&:hover": {
        backgroundColor: green[700],
      },
    },
    fabProgress: {
      color: green[500],
      position: "absolute",
      top: -6,
      left: -6,
      zIndex: 1,
    },
    buttonProgress: {
      color: green[500],
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: -12,
      marginLeft: -12,
    },
  }));
  
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  function AuthScreen(props) {
    const [alertMessage, setAlertMessage] = useState({
      open: false,
      message: "",
    });
    const appDispatch = useContext(DispatchContext);
    const appState = useContext(StateContext);
    // const [loginValues, setLoginValues] = useState({ email: "", password: "" });
    const { t } = useTranslation();
    
    let history = useHistory();
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(true)
  
    const handleLogout = () => {
    };
  
  
    const goToAuth = () => {
      if (getCookie("Profile") && getCookie("tokenAuth")) {
         const profile = parseCookieJson(getCookie("Profile"));
         if (!profile) {
           erase("tokenAuth");
           erase("Profile");
           appDispatch({ type: "logout" });
           var shop_url = window.location.href
           var auth_url = `${process.env.REACT_APP_AUTH_URL}`
           setCookie(`redirect`, shop_url);
           window.location.replace(auth_url);
           return;
         }
         appDispatch({ type: "UpdateProfile", profile });
         appDispatch({ type: "setAuthToken", authToken: getCookie("tokenAuth") });
         appDispatch({type: "login", token: getCookie("tokenAuth"), loggedIn: true, });
         setIsLoading(false);
         history.push(`/dashboard`);
       } else {
        var shop_url = window.location.href
      var auth_url = `${process.env.REACT_APP_AUTH_URL}`
      setCookie(`redirect`, shop_url);
      window.location.replace(auth_url);
         erase("tokenAuth");
         erase("Profile");
        appDispatch({ type: "logout" });
       }
    }
  
    useEffect(() => {
      goToAuth()
   
    }, [])
  useEffect(() =>{
      setTimeout(
        () => setAlertMessage({ open: false, message: "", alertSuccess: false }),
        8000
      );
    }, [alertMessage.open]);
  
    if(isLoading){
        return (
            <div>
            <LoaderAnimation />
            </div>
        )
    }
    return (
      <Page title="Login">
       
      </Page>
    );
  }
  
  export default withTranslation()(AuthScreen);
  